import React from 'react'
import style from "./style.scss";

const RatingPlaceHolder = ({ updateSelection, onChange, selected, index }) => {
    return (
        <div
            className={`${style['scale-box']} ${index <= selected ? style['selected'] : ''} ${selected > 0 ? (index <= 6 ? style['poor'] : index <= 8 ? style['good'] : style['best']) : ''}`}
            id={index}
            onClick={(e) => {
                updateSelection(e.target.id);
                onChange(e.target.id);
            }}
        >
            <span id={index}>{index}</span>
        </div>
    )
}

export default RatingPlaceHolder